import { defineComponent as _defineComponent } from 'vue'
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpCaptcha from "@rmp/core/components/fields/RmpCaptcha.vue";
import RmpBottomSpace from "@rmp/core/components/layouts/RmpBottomSpace.vue";
import { useI18n } from "vue-i18n-composable";
import RmpSelectCounterpartyStep from "@rmp/id/views/masterAccountAccess/steps/RmpSelectCounterpartyStep.vue";
import RmpContactInformationStep from "@rmp/id/views/masterAccountAccess/steps/RmpContactInformationStep.vue";
import RmpSignApplicationStep from "@rmp/id/views/masterAccountAccess/steps/RmpSignApplicationStep.vue";
import RmpDocumentsStep from "@rmp/id/views/masterAccountAccess/steps/RmpDocumentsStep.vue";
import RmpFinalStep from "@rmp/id/views/masterAccountAccess/steps/RmpFinalStep.vue";
import { computed } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { MasterAccountApplicationStepOrdersEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountApplicationStepOrdersEnum";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { storeToRefs } from "pinia";
import RmpSelectBranchStep from "@rmp/id/views/masterAccountAccess/steps/RmpSelectBranchStep.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpMasterAccountAccess',
  setup(__props) {

const { tc } = useI18n();

const useStore = useMasterAccountAccessStore;
const store = useStore();

let {
	createMasterAccountRequestOperationExecuting,
	nextStepAvailable,
	prevStepAvailable,
	currentStepIndex,
	firstStep,
	finalStep,
	captchaRequired,
	captchaToken
} = storeToRefs(store);

const {
	handleNextStep,
	handlePrevStep
} = useStore();

const masterAccountApplicationStepsMap = new Map([
	[MasterAccountApplicationStepOrdersEnum.SELECT_COUNTERPARTY_STEP_ORDER, RmpSelectCounterpartyStep],
	[MasterAccountApplicationStepOrdersEnum.CONTACT_INFORMATION_STEP_ORDER, RmpContactInformationStep],
	[MasterAccountApplicationStepOrdersEnum.SELECT_BRANCH_STEP_ORDER, RmpSelectBranchStep],
	[MasterAccountApplicationStepOrdersEnum.SIGN_APPLICATION_STEP_ORDER, RmpSignApplicationStep],
	[MasterAccountApplicationStepOrdersEnum.DOCUMENTS_STEP_ORDER, RmpDocumentsStep],
	[MasterAccountApplicationStepOrdersEnum.FINAL_STEP_ORDER, RmpFinalStep]
]);

const availableIndexedSteps = computed(() => {
	return store.steps.map((x, i) => ({
		index: i,
		value: x,
		title: tc(`aliases.masterAccountApplicationStep.${x}`),
		component: masterAccountApplicationStepsMap.get(x)
	}));
});

const { initialized } = usePage({ useStore });

const canGoBack = computed(() => {
	return history.length > 2;
});

const handleEnterKey = (event: KeyboardEvent) => {
	if(!finalStep.value && nextStepAvailable.value) {
		handleNextStep();
	}
};

return { __sfc: true,tc, useStore, store, createMasterAccountRequestOperationExecuting, nextStepAvailable, prevStepAvailable, currentStepIndex, firstStep, finalStep, captchaRequired, captchaToken, handleNextStep, handlePrevStep, masterAccountApplicationStepsMap, availableIndexedSteps, initialized, canGoBack, handleEnterKey, RmpBtn, RmpCaptcha, RmpBottomSpace }
}

})